// Campus photo for /colleges/auburn-university: CC BY 2.0, by dregsplod from Tulsa, Oklahoma, USA, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AAuburn_campus_with_Samford_Hall.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/auburn-university/; credited under the photo.
const photo = {
    "slug": "auburn-university",
    "alt": "Samford Hall and its clock tower above the campus lawns at Auburn University in Auburn, Alabama",
    "src": "/colleges/auburn-university/campus-1600.webp",
    "srcSmall": "/colleges/auburn-university/campus-800.webp",
    "srcMid": "/colleges/auburn-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/auburn-university/og.jpg",
    "title": "Auburn campus with Samford Hall",
    "author": "dregsplod from Tulsa, Oklahoma, USA",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AAuburn_campus_with_Samford_Hall.jpg",
    "read": "2026-10-01"
};

export default photo;
